import { QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";

import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth/auth-context";
import { createQueryClient } from "@/lib/query/query-client";
import { ThematicPalettes } from "@/lib/thematic";

// Side-effect import: initialize i18next before anything renders.
import "@/lib/i18n/i18n";

/**
 * App-wide providers, ordered so each layer can use the one above it:
 *   QueryClient → Auth (uses Query) → routed app.
 * The toaster (Django-messages equivalent) is mounted once here.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  // One QueryClient per app instance, stable across renders.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <ThematicPalettes />
      <AuthProvider>
        {children}
        <Toaster richColors closeButton position="top-right" />
      </AuthProvider>
    </QueryClientProvider>
  );
}
